require('./bootstrap');
require('./swiper');
require('./aos');

$(window).scroll(function () {
  const scroll = $(window).scrollTop();
  $('[data-scroll-detection]').toggleClass('scrolled', scroll > 0);
});